import React from 'react';

import { DetailPageLayout, Tabs } from 'src/components/common';

import { VerifierBillingSettingsTabs } from './constants';

export const VerifierDetailBillingSettingsClearVerifyAdminManagerPage: React.FC = () => {
  return (
    <DetailPageLayout titleContent="Billing Settings">
      <Tabs tabs={VerifierBillingSettingsTabs} contentStyles={{ mt: 3 }} />
    </DetailPageLayout>
  );
};
